module.exports = __webpack_public_path__ + "static/media/recharge_help.1773dac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/recharge_help.png
// module id = 3833
// module chunks = 1